"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFilterAction = exports.removeAllFiltersAction = exports.addBatchFilterAction = exports.addUpdatedFiltersAction = exports.addFilterAction = exports.FILTER_BAR_REMOVE_ALL_FILTERS_ACTION = exports.FILTER_BAR_ADD_BATCH_FILTER_ACTION = exports.FILTER_BAR_ADD_UPDATED_FILTERS_ACTION = exports.FILTER_BAR_ADD_FILTER_ACTION = exports.FILTER_BAR_REMOVE_FILTER_ACTION = void 0;
var filterBar_1 = require("../utils/filterBar");
/* ACTIONS */
exports.FILTER_BAR_REMOVE_FILTER_ACTION = 'FILTER_BAR_REMOVE_FILTER_ACTION';
exports.FILTER_BAR_ADD_FILTER_ACTION = 'FILTER_BAR_ADD_FILTER_ACTION';
exports.FILTER_BAR_ADD_UPDATED_FILTERS_ACTION = 'FILTER_BAR_ADD_UPDATED_FILTERS_ACTION';
exports.FILTER_BAR_ADD_BATCH_FILTER_ACTION = 'FILTER_BAR_ADD_BATCH_FILTER_ACTION';
exports.FILTER_BAR_REMOVE_ALL_FILTERS_ACTION = 'FILTER_BAR_REMOVE_ALL_FILTERS_ACTION';
/* DISPATCHERS */
var addFilterAction = function (filter) { return function (dispatch) {
    dispatch({
        type: exports.FILTER_BAR_ADD_FILTER_ACTION,
        payload: __assign({}, filter),
    });
}; };
exports.addFilterAction = addFilterAction;
var addUpdatedFiltersAction = function (filterId, updatedAppliedFilters) { return function (dispatch) { return dispatch({
    type: exports.FILTER_BAR_ADD_UPDATED_FILTERS_ACTION,
    payload: {
        filterId: filterId,
        updatedAppliedFilters: updatedAppliedFilters,
    },
}); }; };
exports.addUpdatedFiltersAction = addUpdatedFiltersAction;
var addBatchFilterAction = function (filters) { return function (dispatch) { return dispatch({
    type: exports.FILTER_BAR_ADD_BATCH_FILTER_ACTION,
    payload: __assign({}, filters),
}); }; };
exports.addBatchFilterAction = addBatchFilterAction;
var removeAllFiltersAction = function (filterId, sectionId) { return function (dispatch) { return dispatch({
    type: exports.FILTER_BAR_REMOVE_ALL_FILTERS_ACTION,
    payload: { filterId: filterId, sectionId: sectionId },
}); }; };
exports.removeAllFiltersAction = removeAllFiltersAction;
var removeFilterAction = function (filter) { return function (dispatch) { return dispatch({
    type: exports.FILTER_BAR_REMOVE_FILTER_ACTION,
    payload: __assign({}, filter),
}); }; };
exports.removeFilterAction = removeFilterAction;
/** **********************
 * REDUCER
 *********************** */
// eslint-disable-next-line default-param-last
function filterBarReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (state === void 0) { state = {}; }
    var filterId = action.payload && action.payload.filterId;
    var sectionId = action.payload && action.payload.sectionId;
    switch (action.type) {
        case exports.FILTER_BAR_ADD_UPDATED_FILTERS_ACTION: return __assign(__assign({}, state), (_a = {}, _a[filterId] = action.payload.updatedAppliedFilters, _a));
        case exports.FILTER_BAR_REMOVE_FILTER_ACTION: return __assign(__assign({}, state), (_b = {}, _b[filterId] = __assign(__assign({}, state[filterId]), (_c = {}, _c[sectionId] = (0, filterBar_1.removeFilter)(state[filterId], sectionId, action.payload.value), _c)), _b));
        case exports.FILTER_BAR_ADD_FILTER_ACTION:
            return __assign(__assign({}, state), (_d = {}, _d[filterId] = state[filterId] || {}, _d[filterId] = (0, filterBar_1.addFilter)(state[filterId], sectionId, action.payload.value), _d));
        case exports.FILTER_BAR_ADD_BATCH_FILTER_ACTION: return __assign(__assign({}, state), (_e = {}, _e[filterId] = state[filterId][sectionId]
            ? __assign(__assign({}, state[filterId]), (_f = {}, _f[sectionId] = __spreadArray(__spreadArray([], state[filterId][sectionId], true), action.payload.values, true), _f)) : __assign(__assign({}, state[filterId]), (_g = {}, _g[sectionId] = __spreadArray([], action.payload.values, true), _g)), _e));
        case exports.FILTER_BAR_REMOVE_ALL_FILTERS_ACTION: return __assign(__assign({}, state), (_h = {}, _h[filterId] = __assign(__assign({}, state[filterId]), (_j = {}, _j[sectionId] = [], _j)), _h));
        default: return state;
    }
}
exports.default = filterBarReducer;
